import React from "react";
import Nav from "../components/Nav";
import Circles from "../components/Circles";

function Rules({noNav}) {
  console.log("aaaa",noNav);
  return (
    <section className="bg-petrol-500">
      {!noNav && <Nav />}
      <div>{noNav}</div>
      <div className="container text">
        <h1 className="mb-8 self-center">Tävlingsregler</h1>
        <p className="mb-4">
        För att få chans att vinna 30 000 kr* i presentkort på Frölunda Torg måste du vara en av de topp 8 bland tävlanden** i Frölunda Torgs digitala quiz, samt vara minst 16 år gammal. De som är i topp 8 får möjlighet att medverka i ett finalevent som utspelas inför publik på Frölunda Torg där den slutgiltiga vinnaren koras. Finalen sker i Centralhallen på Frölunda Torg lördag 27 april kl 12–15. Finalisterna utses och blir kontaktade 22–24 april.
        </p>
        <p className="mb-4">
        3000 kr i presentkort på Frölunda Torg går till andrapristagaren och 2000 kr i presentkort på Frölunda Torg till tredjepristagaren. Vinnarna kommer att utses genom flest antal rätt svar på kortast tid, och frågorna kommer att röra Frölunda Torg, liksom det digitala quizet.
        </p>
        <p className="mb-4">
        Vinnarna hämtar ut sina presentkort på Frölunda Torgs Infocenter. Legitimation/ID-handling krävs för att du ska kunna hämta ut ditt presentkort. Du måste personligen hämta ut din vinst.
        </p>
        <p className="mb-4">
        Om vi inte får tag på dig, via den mailadress eller det telefonnummer som du angivit, inom 24 timmar från första kontakt, går din finalplats vidare till nästa person på topplistan. Detsamma gäller om du inte har möjlighet att medverka vid finaleventet.
        </p>
        <p className="mb-4">
        Vid medverkan under finaleventet godkänner du (och din ev målsman) att Frölunda Torg, och deras samarbetspartners, fotograferar och filmar finaleventet. Materialet kommer visas på hemsida samt i sociala medier i anknytning till Frölunda Torgs marknadsföring om quizet. 
        </p>
        <p className="mb-4">
        Under 5 veckor kommer även 5 veckovinnare att utses, dessa vinnare får vardera ett presentkort á 1000 kr/st. Den som ligger högst upp på topplistan kl 23:59 på söndagen vinner. Vinnare för varje vecka kommer att kontaktas senast tisdagen efterföljande vecka. Du har endast möjlighet att vinna ett presentkort på 1000 kr. Om du är nr 1 på topplistan i flera veckor så går vinsten istället vidare till nästa kvalificerade person. Din chans att gå till slutfinal påverkas inte av att du redan har vunnit 1000 kr. Vid vinst godkänner du att ditt namn publiceras i Frölunda Torgs sociala kanaler och hemsida.
        </p>
        <p className="mb-4">
        Det finns inga restriktioner kring hur många gånger du får tävla.
        </p>
        <p className="mb-4">
        * Eventuell vinstskatt betalas av vinnaren.<br/>
** Tävlingsresultat är baserat på flest antal rätt svar på kortast tid samt en utslagsfråga om flera personer har samma antal rätta svar på samma tid.
        </p>
      </div>
    </section>
  );
}

export default Rules;
